import IPathModel from 'Models/PathModel'
import AccountPaths from './AccountPaths'
import AccountPage from 'Application/Account/Pages';

const AccountRoutes: IPathModel[] = [
  {
    path: AccountPaths.AccountMain,
    element: AccountPage
  }
]

export default AccountRoutes